import { Component, OnInit } from '@angular/core';
import { AuthService, ConstantService, HelperService, ApiService, PaginationService } from '../../core/services';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-all-podcast-list',
  templateUrl: './all-podcast-list.component.html',
  styleUrls: ['./all-podcast-list.component.css']
})
export class AllPodcastListComponent implements OnInit {

  podcastCategory: any = '';
  userSubscription: Subscription;
  catAlias: any = '';
  nextPage: any = 0;
  podcastList:any = [];
  apiCalled:boolean = false;
  podcastCategoryList:any = [];

  public loadScript() {
    var isFound = false;
    var scripts: any = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null) {
        isFound = false;
        if (scripts[i].getAttribute('src').includes("assets/js/bootstrap.min.js")) {
          scripts[i].parentNode.removeChild(scripts[i])
        }
        if (scripts[i].getAttribute('src').includes("assets/js/popper.min.js")) {
          scripts[i].parentNode.removeChild(scripts[i])
        }

      }
    }
    if (!isFound) {
      var dynamicScripts = ["assets/js/bootstrap.min.js","assets/js/popper.min.js"];
      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  }

  constructor(private authSvc: AuthService,
    private constantSvc: ConstantService,
    private apiSvc: ApiService,
    private helperSvc: HelperService,
    private pagerService: PaginationService,
    private router: Router, private spinner: NgxSpinnerService,

    private _route: ActivatedRoute) {
    this.userSubscription = this._route.params.subscribe(
      (params: Params) => {
        const desc = this._route.snapshot.paramMap.get('cat')!;
        let alias = desc;
        this.catAlias = desc;
        this.getPodcastCategoryList(alias);
        this.getPodcastCatList();
      })
  }

  ngOnInit(): void {
    // this.getPodcastCategoryList();
  }

  getPodcastCategoryList(alias) {
    this.spinner.show();
    this.apiSvc.getService(this.constantSvc.APIConfig.GETALLPODCASTBYCATEGORYALIAS, '?alias=' + alias).subscribe(
      res => {
        if (res) {
          this.podcastCategory = res;
          this.podcastList = res.podcasts;
          // this.nextPage = res.next_page;
          this.apiCalled = true;
          this.spinner.hide();
        }
      }, err => {
        this.spinner.hide();
      }
    );
  }

  getPodcastCatList() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETPODCASTCATEGORYLIST, '').subscribe(
      res => {
        if (res) {
          let data = res;
          this.podcastCategoryList = data.categories;
          // this.loadScript();

        }
      }, err => {
      }
    );
  }

  // loadMorePodcasts() {
  //   this.apiSvc.getService(this.constantSvc.APIConfig.GETALLPODCASTBYCATEGORYALIAS, '?alias=' + this.catAlias + '&page=' + this.nextPage).subscribe(
  //     res => {
  //       if (res) {
  //         // this.podcastCategory = res;
  //         let nextpodcast = res.podcasts;
  //         this.podcastList =  this.podcastList.concat(nextpodcast);
  //         this.nextPage = res.next_page;
  //       }
  //     }, err => {
  //     }
  //   );
  // }

}
